import { FormField } from './FormField';
import { PlusIcon } from '../ecardsPreact.icons/PlusIcon';
import { PreviewState } from '../ecardsPreact.constants/previewState';
import { Steps } from '../ecardsPreact.constants/steps';
import RecipientFields from './RecipientFields';
import { ChevronIcon } from '../ecardsPreact.icons/ChevronIcon';
import { useContext, useEffect, useState } from 'preact/hooks';
import { Directions } from '../ecardsPreact.constants/directions';
import { ECardGlobalState } from './ECardGlobalState';
import { FileUploadField } from './FileUploadField';
import { FieldError } from './FieldError';

export default function ECardStepPersonalise(props) {
    const { handleChange, setPreviewState, recipients, hidden, maxRecipients, imageUploadNotLoaded } = props;

    const [allRecipientsHidden, setAllRecipientsHidden] = useState(true);
    const { currentStep, maxRecipientsVisible, isGtmCard } = useContext(ECardGlobalState);

    const handleOnChange = (e) => {
        handleChange(e);
        setPreviewState(PreviewState.Back);
    };

    useEffect(() => {
        setAllRecipientsHidden(maxRecipientsVisible.get !== -1);
    }, [maxRecipientsVisible.get]);

    return (
        <section class="ecard-form__section" hidden={hidden} aria-labelledby="personalise-step-head">
            <button hidden class="ecard-form__scroll-button" type="button" data-recipient-list-scroll-button>
                <span class="sr-only">Scroll to top</span>
                <svg
                    class="icon-arrow"
                    xmlns="http://www.w3.org/2000/svg"
                    width="32"
                    height="32"
                    fill="none"
                    focusable="false"
                    aria-hidden="true"
                    viewBox="0 0 32 32"
                >
                    <path
                        fill="currentColor"
                        d="M15.6 29c.12-.02.49-.11.52-.14l.3-.16c.25-.14.32-.2.5-.42.1-.13.11-.16.03-.28-.13-.2-.17-.62-.2-2.32-.04-2.21-.08-3.52-.12-4.3a154.18 154.18 0 0 1-.3-9.48c.04-.53.1-2.75.1-3.37 0-.69-.01-.8-.1-.9-.06-.06-.06-.1-.08-.96l-.01-.9.06.06.48.6A43.99 43.99 0 0 0 19.6 9.6c.17.18.59.6.92.96l.93.97a116.45 116.45 0 0 0 3.34 3.39c.05.07.13.13.23.18.14.07.15.07.36.04.2-.03.38-.1.7-.3l.34-.18c.12-.06.2-.12.25-.2l.21-.27c.12-.14.14-.18.13-.24a.71.71 0 0 0-.24-.34c-.06-.04-.5-.48-1-.97-.8-.8-1.23-1.22-2.92-2.82l-1.25-1.18a47.15 47.15 0 0 0-3.78-3.3c-1.07-.83-1.39-1.1-1.55-1.26-.27-.26-1.05-.9-1.25-1-.1-.07-.15-.08-.23-.06a.45.45 0 0 0-.18.08 6.65 6.65 0 0 0-.99.93c-.62.66-1.98 2.32-4.16 5.07L7.8 11.16c-1.89 2.36-2.17 2.73-2.4 3.2l-.2.38a.66.66 0 0 0-.07.18c0 .02-.04.08-.07.12-.06.06-.07.1-.05.2a4.31 4.31 0 0 0 .14.74c.04.18.07.2.2.27.2.08.36.03.92-.28.2-.11.32-.2.58-.46.53-.5.83-.88 3.13-3.87L12.1 8.9l1.39-1.82.61-.8.02.18.09 1.2.2 2.74c.13 1.56.14 1.8.13 2.22l-.02 4.25c0 2.07-.02 4.71-.03 5.87a20.73 20.73 0 0 1-.09 2.59c-.05.42-.06.6-.06 1.4 0 .69.01.95.04 1.04.04.15.36.8.5 1.02a.6.6 0 0 0 .15.17c.07.03.45.05.57.04Z"
                    ></path>
                </svg>
            </button>
            <header class="ecard-form__header">
                <p class="ecard-form__step-count">Step 1 of {isGtmCard ? 3 : 4}</p>
                <h1 class="ecard-form__title text-form-h1 text-blue" id="personalise-step-head">
                    Personalise your&nbsp;card
                </h1>
            </header>

            <div class="recipient-fields">
                <RecipientFields handleChange={handleChange} recipients={recipients} setPreviewState={setPreviewState} />

                {!isGtmCard && recipients && recipients.length < maxRecipients && (
                    <button
                        type="button"
                        class="plus-button recipient-fields__add"
                        onClick={() => {
                            currentStep.set(Steps.AddRecipientsOptions);
                        }}
                    >
                        <PlusIcon width="21" height="21" class="plus-button__icon " />
                        <span>Send to multiple recipients (max {maxRecipients})</span>
                    </button>
                )}

                {!isGtmCard && recipients && recipients.length > 3 && (
                    <button
                        type="button"
                        class={`recipient-fields__toggle view-all-toggle${allRecipientsHidden ? ' view-all-toggle--hide' : ''}`}
                        onClick={() => {
                            // TODO: maxRecipientsVisible is for future proofing showing more than 3 recipients. At the moment it toggles between 3 and all, but this should make it easier to show more in batches in the future.
                            maxRecipientsVisible.set(maxRecipientsVisible.get !== -1 ? -1 : 3);
                        }}
                    >
                        {allRecipientsHidden ? 'Show all' : 'Hide'} recipients ({recipients.length})
                        <ChevronIcon width="28" height="28" direction={allRecipientsHidden ? Directions.Down : Directions.Up} />
                    </button>
                )}
            </div>
            <FormField
                type="textarea"
                name={`EcardMessageDetails.Message`}
                label="Enter your message... Don't forget to say who it's from!"
                placeholder="Enter message&hellip;"
                required
                characterLimit={240}
                onChange={handleOnChange}
            />
            <FormField
                type="text"
                name={`EcardMessageDetails.FromName`}
                label="Who's it from? We'll use this name when we email the recipient."
                placeholder="Enter your name&hellip;"
                required
                onChange={handleOnChange}
            />

            <FileUploadField
                name="EcardMessageDetails.ImageToUpload"
                label="Upload a logo image"
                helpText="Accepted file types are .jpg, .jpeg, .png, .gif. The file must be smaller than 200kb."
                buttonText="Click to upload"
                onChange={() => {
                    setPreviewState(PreviewState.Back);
                }}
            />
            <FieldError
                error="There was an issue when trying to display your uploaded image. A reference was found, but no file was retrieved"
                touched={imageUploadNotLoaded}
            />

            {isGtmCard && (
                <FormField
                    type="checkbox"
                    wrapperClass="checked-item--small-label"
                    name="EcardMessageDetails.DonationVisible"
                    label="Display this donation on the card"
                />
            )}
        </section>
    );
}
